import { useEffect, useState } from "react";
import { brDateHourFormat } from "../../../helpers/date.helpers";
import { Observation } from "../../../../types/vehicle.type";
import { FileObservations } from "./FileObservations";


type ObservationsProps = {
  initialObservations?: Observation[];
  author: string;
  onAddObservation?: (newObservation: Observation) => void;
  entityId: string;
  entityType: string;
};

export function Observations({
  initialObservations = [],
  author,
  onAddObservation,
  entityId,
  entityType,
}: ObservationsProps) {
  const [newObservation, setNewObservation] = useState(""); // Estado para a nova observação
  const [currentFilePath, setCurrentFilePath] = useState("");
  const [observations, setObservations] = useState(initialObservations); // Estado para as observações

  // Sincroniza as observações do banco sempre que initialObservations mudar
  useEffect(() => {
    setObservations(initialObservations);
  }, [initialObservations]);

  const handleAddObservation = () => {
    if (!newObservation.trim()) return; // Não adiciona observações vazias

    const newObs: Observation = {
      date: new Date().toISOString(), // Converte a data para string
      text: newObservation,
      author,
      currentPath: currentFilePath, // Adiciona o caminho do arquivo
    };

    // Atualiza o estado local e chama o callback externo
    setObservations((prev) => [newObs, ...prev]);
    onAddObservation?.(newObs); // Chama o callback externo, se fornecido
    setNewObservation(""); // Limpa o campo de texto
  };

  return (
    <div className="w-full">
      <div className="w-full border border-gray/40 shadow-md rounded bg-white/60 p-4 mb-4 justify-between">
        <textarea
          value={newObservation}
          onChange={(e) => setNewObservation(e.target.value)}
          placeholder="Digite sua observação aqui..."
          className="w-full border border-gray-300 rounded p-2 resize-none focus:ring focus:ring-blue-500"
          rows={4}
        />
        <div className=" flex justify-between items-center">
          <button
            onClick={handleAddObservation}
            className="bg-redPrimary text-white font-semibold p-2 rounded-md mt-2"
          >
            Adicionar observação
          </button>
          <FileObservations
            onFileUploaded={setCurrentFilePath}
            pathToUpload={`${entityType}/${entityId}`}
            nameFile="Anexar Arquivo"
            currentPath=""
          />
        </div>
      </div>

      {/* Lista de observações */}
      <div className="w-full min-h-[80px] border border-gray/40 shadow-md rounded bg-white/60 p-2">
        <section>
          {observations.map((observation, index) => (
            <div
              key={index}
              className="w-full bg-gray/10 my-4 p-2 rounded-md border border-gray/40"
            >
              <label className="font-semibold">
                {brDateHourFormat(observation.date)}
              </label>
              <p className="whitespace-pre-wrap">
                <h3 className="font-semibold">Observação:</h3>
                {observation.text}
              </p>
              {observation.currentPath && (
                <a
                  href={`https://assets.locavibe.com.br/${observation.currentPath}`}
                  className="text-bluePrimary"
                  target="_blank"
                >
                  Ver anexo
                </a>
              )}
              <br />
              <p className="font-semibold">Criado por: {observation.author}</p>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
}
